import './tabs.scss';

import { Tabs as MantineTabs } from '@eliberty/design-system-react/mantine';

interface TabsProps {
  tabs: Array<{
    label: string;
    value: string;
    content: React.ReactNode;
  }>;
  defaultValue?: string;
}

/**
 * A generic Tabs component that renders a tabbed interface.
 * Accepts any number of tabs with customizable labels and content via the `tabs` prop.
 */
const Tabs = ({ tabs, defaultValue = 'morning' }: TabsProps) => {
  return (
    <MantineTabs defaultValue={defaultValue}>
      <MantineTabs.List grow>
        {tabs.map((tab) => (
          <MantineTabs.Tab key={tab.value} value={tab.value}>
            {tab.label}
          </MantineTabs.Tab>
        ))}
      </MantineTabs.List>

      {tabs.map((tab) => (
        <MantineTabs.Panel key={tab.value} value={tab.value}>
          {tab.content}
        </MantineTabs.Panel>
      ))}
    </MantineTabs>
  );
};

export default Tabs;
